import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { ReactiveFormsModule } from '@angular/forms';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment as env } from '@env/environment';
import { SupportPublicRoutingModule } from '@app/features/muni-support/muni-support-routing.module';
import { MuniSupportComponent } from '@app/features/muni-support/muni-support.component';
import { SelectMunicipalityComponent } from './pages/select-municipality/select-municipality.component';
import { ClientServicesDialog } from './components/client-services-dialog/client-services-dialog';
import { MissedServiceComponent } from './components/missed-service/missed-service.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SupportPublicRoutingModule,
    MDBBootstrapModule.forRoot(),
    ReactiveFormsModule,
    RecaptchaV3Module,
  ],
  declarations: [
    ClientServicesDialog,
    MissedServiceComponent,
    MuniSupportComponent,
    SelectMunicipalityComponent,
  ],
  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: env.recaptchaKey }],
})
export class MuniSupportModule {}
